<template>
  <router-link class="box" :to="`/reports/${site}/${dataType}`">
    <h2>{{ dataType }} {{ period }}:</h2>
    <h2>{{ site }} <span v-if="site == 'all'">sites</span></h2>
    <h1 class="blue" v-if="dataType == 'sales'"><CurrencyFormatter :value="current" :currency="companySettings.currency"/></h1>
    <h1 class="blue" v-else>{{ current }} units</h1>
    <h5>Last <span v-if="period == 'today'">Week</span> {{ period }}</h5>
    <h5 v-if="dataType == 'sales'"><CurrencyFormatter :value="previous" :currency="companySettings.currency"/></h5>
    <h5 v-else>{{ previous }} units</h5>
    <h5 :class="current < previous ? 'negative' : 'positive'">{{ percentage }} %</h5>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@monolith/helpers";
import { dayRange, reports } from "@monolith/helpers";
import { CurrencyFormatter } from "@monolith/components";

export default {
  name: "ReportsComponent",
  data() {
    return {
      current: 0,
      previous: 0,
      percentage: 0,
    };
  },
  components: {
    CurrencyFormatter,
  },
  props: {
    editData: {
      type: Boolean,
      required: false,
    },
    period: {
      type: String,
      required: true,
    },
    dataType: {
      type: String,
      required: true,
    },
    site: {
      type: String,
      required: true,
    },
    day: {
      type: Array,
      required: true,
    },
    otherDay: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      sites: "sites",
      reportSite: "reportSite",
      companyName: "companyName",
      companySettings: "companySettings",
    }),
  },

  methods: {
    async getTotals(start, end) {
      if (this.dataType == "sales") {
        return await api.get_sales_total(this.site, start, end);
      } else {
        return await api.get_count_total(this.site, start, end);
      }
    },

    fixCurrency(total) {
      let fixed = reports.currencyFormat(total);
      return fixed;
    },

    async collectData() {
      const result = await this.getTotals(this.day[0], this.day[1]);
      this.current = result[0] ? result[0].value : 0;

      const response = await this.getTotals(this.otherDay[0], this.otherDay[1]);
      this.previous = response[0] ? response[0].value : 0;

      let percentage = this.percentageTotal(this.current, this.previous)

      return percentage;
    },

    percentageTotal(value1, value2) {
      this.percentage = parseInt((((value1 - value2) / value2) * 100).toFixed(2));
    },

    editDashItem() {},
  },

  mounted() {
    this.collectData();
  },

  watch: {
    site: function () {
      this.collectData();
    },
    dataType: function () {
      this.collectData();
    },
    currentDay: function () {
      this.collectData();
    },
    editData: function () {
      this.editDashItem();
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 0.75rem 1rem;
  gap: 0.15rem;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.8;
  }

  h2,
  h1,
  h3 {
    margin: 0;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  h1 {
    font-size: clamp(1rem, 4cqw, 1.6rem);
  }

  h2 {
    font-size: clamp(0.7rem, 2.5cqw, 0.95rem);
    opacity: 0.7;
  }

  h5 {
    margin: 0;
    font-size: clamp(0.65rem, 2cqw, 0.8rem);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .blue {
    color: var(--action-colour);
  }
  .negative {
    color: rgb(202, 45, 45);
  }
  .positive {
    color: rgb(45, 129, 45);
  }
}

@media only screen and (orientation: portrait) {
  .box {
    padding: 0.5rem 0.75rem;

    h1 {
      font-size: 1.1rem;
    }

    h2 {
      font-size: 0.75rem;
    }

    h5 {
      font-size: 0.7rem;
    }
  }
}
</style>
